import styled from "@emotion/styled";
import { ListBox, ListBoxItem, Popover, Select, SelectValue } from "react-aria-components";
import { IMDSSelectItemProps, IMDSSelectProps } from "./select.types";

export const StyledSelect = styled(Select)<IMDSSelectProps>``;

export const StyledListBox = styled(ListBox)`
  width: 100%;
` as typeof ListBox<IMDSSelectItemProps>;

export const StyledListBoxItem = styled(ListBoxItem)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  padding: ${({ theme }) => theme.spacing.md} ${({ theme }) => theme.spacing.md};
  width: 100%;
  font-size: ${({ theme }) => theme.fontSizes.small};

  border-radius: ${({ theme }) => theme.borderRadius.medium}px;
  outline: none;

  user-select: none;
  cursor: pointer;

  &[data-focused] {
    background-color: ${({ theme }) => theme.colors.grey.x50};
  }

  &[data-selected] {
    background-color: ${({ theme }) => theme.colors.mblue.x50};
  }

  &:hover:not([data-disabled]) {
    background-color: ${({ theme }) => theme.colors.grey.x50};
  }

  &[data-disabled] {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const StyledSelectValue = styled(SelectValue)`
  max-width: 100%;
  font-size: ${({ theme }) => theme.fontSizes.small};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  color: ${({ theme }) => theme.colors.grey.x800};

  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const StyledButtonContent = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.sm};
`;

export const StyledPopover = styled(Popover)`
  background: ${({ theme }) => theme.colors.grey.x0};
  border: 1px solid ${({ theme }) => theme.colors.grey.x100};
  border-radius: ${({ theme }) => theme.borderRadius.mediumLarge}px;
  box-shadow: ${({ theme }) => theme.shadows.popover};
`;
